import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconParentBackUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.30643 4.06514C9.21285 4.02328 9.10915 4 9 4C8.89523 4 8.79546 4.02145 8.70486 4.06021C8.61979 4.09651 8.54005 4.14925 8.47049 4.2184L8.46888 4.22001L4.21999 8.4689C3.92667 8.76222 3.92667 9.2378 4.21999 9.53112C4.51332 9.82445 4.98889 9.82445 5.28222 9.53112L8.2489 6.56444V12.7478C8.2489 12.7616 8.24927 12.7753 8.25 12.7889V16.25C8.25 18.3211 9.92893 20 12 20H18.5C18.9142 20 19.25 19.6642 19.25 19.25C19.25 18.8358 18.9142 18.5 18.5 18.5H12C10.7574 18.5 9.75 17.4926 9.75 16.25V12.789C9.75074 12.7753 9.75111 12.7616 9.75111 12.7478V6.56446L12.7178 9.53113C13.0111 9.82445 13.4867 9.82445 13.78 9.53113C14.0733 9.2378 14.0733 8.76223 13.78 8.4689L9.5311 4.22001C9.5199 4.20881 9.50844 4.19803 9.49673 4.18769L9.30643 4.06514Z",
		fill: "currentColor"
	})
});
export { SvgIconParentBackUp as ReactComponent };
